import ClubBankAccountFinleap from '../dto/ClubBankAccountFinleap';
import ClubTransactionFinleap from '../dto/ClubTransactionFinleap';
import Error from '../model/Error';
import FinleapConnectSession from '../dto/FinleapConnectSession';
import axios from 'axios';

export default class FinleapConnectRepository {

    static getSessionByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/finleap-connect/session`)
                .then(response => resolve(FinleapConnectSession.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateSession(clubId, state, authCode) {
        return new Promise((resolve, reject) => {
            const data = { state: state, authCode: authCode };
            axios
                .put(`/club/clubs/${clubId}/finleap-connect/session`, data)
                .then(response => resolve(FinleapConnectSession.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getRegShieldTokenByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/finleap-connect/reg-shield-token`)
                .then(response => resolve(response.data.data))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getBankAccountsByClubId(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-bank-accounts/finleap-connect`)
                .then(response => resolve(response.data.data.map(bankAccount => ClubBankAccountFinleap.fromData(bankAccount))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getCountAndTransactionsByBankAccountIdAndFilters(bankAccountId, countQuery, fullQuery) {
        return Promise.all([
            this.getTransactionCountByBankAccountIdAndQuery(bankAccountId, countQuery),
            this.getTransactionsByBankAccountIdAndQuery(bankAccountId, fullQuery),
        ]);
    }

    static getTransactionCountByBankAccountIdAndQuery(bankAccountId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/club-bank-accounts/${bankAccountId}/transactions-finleap/count${query}`)
                .then(response => resolve(response.data.data.count))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static getTransactionsByBankAccountIdAndQuery(bankAccountId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/club-bank-accounts/${bankAccountId}/transactions-finleap${query}`)
                .then(response => resolve(response.data.data.map(transaction => ClubTransactionFinleap.fromData(transaction))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
